import moment from "moment";
import React from "react";
import styled from "styled-components";

import { getStaticUrl } from "js/config";
import { t } from "js/i18n";
import { useScreenSize } from "js/react/hooks/useScreenSize";
import CheckoutController, { CheckoutControllerState } from "js/controllers/CheckoutController";

const FeaturesCard = styled.div<{ useNarrowFormat?: boolean }>`
    background: #f7fafc;
    border: 1px solid #dae9f0;
    border-radius: 2px;
    padding: 20px;
    width: 100%;
    max-width: ${({ useNarrowFormat }) => (useNarrowFormat ? "none" : "280px")};
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

const FeatureItem = styled.div`
    display: flex;
    gap: 8px;
    align-items: flex-start;
    justify-content: flex-start;
    width: 100%;
`;

const FeatureText = styled.span`
    flex: 1;
    font-family: "Source Sans Pro", sans-serif;
    font-weight: 400;
    font-size: 12px;
    line-height: 1.25;
    color: #888888;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

const CheckIcon = getStaticUrl("/images/billing/check-circle.svg");

export const PlanFeatures = CheckoutController.withState(
    function PlanFeatures({ useNarrowFormat = false }: { useNarrowFormat?: boolean } & CheckoutControllerState) {
        const { isMobile } = useScreenSize();

        if (isMobile) {
            return null;
        }

        const isTrial = CheckoutController.availableTrialDays > 0;
        const isAnnual = CheckoutController.billingInterval === "year";
        const trialStartDate = moment().format("MMMM DD, YYYY");
        const trialEndDate = moment().add(CheckoutController.availableTrialDays, "days").format("MMMM DD, YYYY");

        return (
            <FeaturesCard useNarrowFormat={useNarrowFormat}>
                {isTrial && <FeatureItem>
                    <img src={CheckIcon} />
                    <FeatureText>
                        {t("Enjoy a full 14 day free trial, from {{startDate}} to {{endDate}}", { startDate: trialStartDate, endDate: trialEndDate })}
                    </FeatureText>
                </FeatureItem>}

                <FeatureItem>
                    <img src={CheckIcon} />
                    <FeatureText>
                        {t("Your subscription will renew automatically {{interval}}", { interval: t(isAnnual ? "annually" : "monthly") })}
                    </FeatureText>
                </FeatureItem>

                {isTrial && <FeatureItem>
                    <img src={CheckIcon} />
                    <FeatureText>
                        {t("Cancel anytime before your trial ends, and you won't be charged")}
                    </FeatureText>
                </FeatureItem>}
            </FeaturesCard>
        );
    }
);
